// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHero_container__IkzOD","bg":"PageHero_bg__zFsme","inner":"PageHero_inner__B24zK","titleContainer":"PageHero_titleContainer__kOkid","title":"PageHero_title__I4lQf"};